// =================================================================
// Engine: Empiric dose module (PSD §4.2.15 / TODO Task 1.5)
// =================================================================
import { Strategy } from '@amino-pk/shared-types';
import { ok } from './types';
/**
 * Empiric dose + interval from weight + renal (pre-level) (PSD §4.2.15).
 * EI interval ladder: ≥60→24h, ≥40→36h, ≥20→48h, <20→not eligible.
 */
export function computeEmpiricDose(agentParams, dosingWeightKg, crClMlMin, strategy, _indication) {
    const doseMgKg = strategy === Strategy.ExtendedInterval ? agentParams.eiDoseMgKg : agentParams.traditionalDoseMgKg;
    const doseMg = doseMgKg * dosingWeightKg;
    let intervalHr;
    let eligible;
    let reason;
    if (strategy === Strategy.ExtendedInterval) {
        if (crClMlMin >= 60) {
            intervalHr = 24;
            eligible = true;
            reason = 'CrCl ≥ 60 → q24h.';
        }
        else if (crClMlMin >= 40) {
            intervalHr = 36;
            eligible = true;
            reason = 'CrCl 40–59 → q36h.';
        }
        else if (crClMlMin >= 20) {
            intervalHr = 48;
            eligible = true;
            reason = 'CrCl 20–39 → q48h.';
        }
        else {
            intervalHr = 0;
            eligible = false;
            reason = 'CrCl < 20 — not eligible for extended interval; use traditional or dialysis pathway.';
        }
    }
    else {
        // Traditional/dialysis/synergy — interval set by traditional dosing module downstream.
        intervalHr = 0;
        eligible = true;
        reason = `${strategy} strategy — interval computed from Kel/Vd.`;
    }
    return ok({ doseMg, intervalHr, eligible, reason });
}
//# sourceMappingURL=empiric.js.map